import React from "react";

import { EligibilityProvider } from "../../contexts/EligibilityContext";
import InBillboard from "./InBillboard";
import InModal from "./InModal";

const EligibilityWizard = ({
  maintenance,
  maintenanceMessageLine1,
  maintenanceMessageLine2,
}) => {
  return (
    <EligibilityProvider>
      <InBillboard
        maintenance={maintenance}
        maintenanceMessageLine1={maintenanceMessageLine1}
        maintenanceMessageLine2={maintenanceMessageLine2}
      />
      <InModal />
    </EligibilityProvider>
  );
};

export default EligibilityWizard;
